import type { ColumnDef } from "@tanstack/react-table"
import { getCoreRowModel } from "@tanstack/react-table"
import type { FC } from "react"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import type { AerosTableReorderReturn } from "@/components/Tables/Aeros/types/table"
import { PermissionActionType } from "@/constants/permissions"
import type { AssociatedTestTemplate } from "@/graphql/codegen/graphql"
import { usePermissionManager } from "@/hooks/usePermissionManager"

interface AssociatedTestTemplatesTableProps {
  data: AssociatedTestTemplate[]
  isLoading: boolean
  columns: ColumnDef<AssociatedTestTemplate>[]
  onReorder: (data: AerosTableReorderReturn<AssociatedTestTemplate>) => void
}

export const AssociatedTestTemplatesTable: FC<AssociatedTestTemplatesTableProps> = ({
  data,
  isLoading,
  columns,
  onReorder,
}) => {
  const { hasPermissions } = usePermissionManager()

  return (
    <AerosBaseTable
      features={{
        table: {
          stickyHeader: true,
        },
        tanstackOptions: {
          data,
          columns,
          state: {
            isLoading,
          },
          enableSorting: false,
          getCoreRowModel: getCoreRowModel(),
        },
      }}
      draggable={hasPermissions([PermissionActionType.TEST_TEMPLATE_MAINTENANCE])}
      onReorder={(data) => onReorder(data)}
      noDataMessage='No associated test templates found'
    />
  )
}

export default AssociatedTestTemplatesTable
